/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";
import { BackButton } from "ui/Streaming/LiveCommerce/BackButton";

type LayoutProps = {
  isDarkMode: boolean;
  playerHeight: number;
  liveCommerceRef?: React.RefObject<HTMLDivElement>;

  addressSection?: React.ReactNode;
  paymentSection?: React.ReactNode;

  cartLabel?: string;
  itemListSection?: React.ReactNode;
  summarySection: React.ReactNode;

  footerSection?: React.ReactNode;
  handleBackButton: () => void;
};

export const StreamingLiveCommerceCartLayoutV2: React.FC<LayoutProps> = (
  props
) => {
  const classes = liveCommerceCartDesign({
    isDarkModeEnabled: props.isDarkMode,
    THEOPlayerElementHeight: props.playerHeight,
  });

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        height: 100%;
      `}
    >
      <div
        ref={props.liveCommerceRef}
        css={css`
          flex: 1 1 auto;
          width: 100%;
          height: 120px;
          overflow-y: auto;
        `}
      >
        <div
          css={css`
            margin-bottom: 12px;
          `}
        >
          <BackButton
            isDarkMode={props.isDarkMode}
            handleBackButton={props.handleBackButton}
          />
        </div>

        <div css={classes.root}>
          {/* 住所・決済枠 */}
          {props.addressSection}

          {props.paymentSection}

          {/* カートメイン枠 */}
          {props.itemListSection && props.cartLabel && (
            <React.Fragment>
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 16px;
                `}
              >
                <p
                  css={css`
                    color: ${props.isDarkMode ? "#fff" : "#000"};
                    font-size: 16px;
                    font-weight: 700;
                  `}
                >
                  {props.cartLabel}
                </p>
                {props.itemListSection}
              </div>
              {props.summarySection}
            </React.Fragment>
          )}
          {props.footerSection}
        </div>
      </div>
    </div>
  );
};

type LiveCommerceCartDesignProps = {
  THEOPlayerElementHeight: number;
  isDarkModeEnabled: boolean;
};
const liveCommerceCartDesign = (props: LiveCommerceCartDesignProps) => {
  const root = css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media screen and (min-width: 768px) {
      position: relative;
    }
    overflow-y: auto;
    padding-bottom: 16px;
  `;
  const darkHeaderColor = css`
    background-color: #333333;
    color: #fff;
  `;
  const lightHeaderColor = css`
    background-color: #f5f5f5;
    color: #333333;
  `;
  const headerBase = css`
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 12px 16px;
    border-radius: 8px;
    p {
      padding: 0 12px;
      font-size: 14px;
      font-weight: bold;
    }
  `;
  const header = css`
    ${headerBase}
    ${props?.isDarkModeEnabled ? darkHeaderColor : lightHeaderColor}
  `;
  const size = css`
    margin-bottom: 10px;
    color: #b1b1b1;
    font-size: 14px;
  `;
  return {
    root,
    header,
    size,
  };
};

export default StreamingLiveCommerceCartLayoutV2;
